import { withRouter } from 'react-router-dom';
import CreateModule from './CreateModule';

export default withRouter(CreateModule);
